import "core-js/modules/es.array.find-index";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/web.dom-collections.for-each";
import _objectSpread from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
import { examinePkgList, examinePkgDel } from "@/api/gmtool/packageCode";
import addExaminePkg from "./components/addExaminePkg.vue";
import { gmTool } from "@/mixins/index";
export default {
  name: "examinePkg",
  components: {
    addExaminePkg: addExaminePkg
  },
  mixins: [gmTool],
  data: function data() {
    return {
      paramsData: {
        page: 1,
        name: '',
        refresh_interval: ''
      }
    };
  },
  created: function created() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.getList(1);

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  methods: {
    getList: function getList() {
      var _this2 = this;

      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
      this.paramsData.page = e;
      examinePkgList(this.paramsData).then(function (res) {
        if (res.status == 200) {
          if (!res.data.data.length && _this2.paramsData.page > 1) {
            _this2.getList(_this2.paramsData.page - 1);
          } else {
            _this2.tableData = res.data.data;
            _this2.total = res.data.total;
          }
        }
      });
    },
    handleSelectionChange: function handleSelectionChange(val) {
      var _this3 = this;

      this.sels = [];
      val.forEach(function (e) {
        if (_this3.tableData.findIndex(function (i) {
          return i.id == e.id;
        }) > -1) {
          _this3.sels.push(e.id);
        }
      });
      this.selsString = this.sels.toString();
    },
    // 删除配置
    handleDelete: function handleDelete(id) {
      var _this4 = this;

      this.$confirm("此操作将删除, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                examinePkgDel(_objectSpread({
                  id: id
                }, _this4.paramsData)).then(function (res) {
                  if (res.status == 200) {
                    _this4.getList(_this4.paramsData.page);

                    _this4.$message({
                      type: "success",
                      message: '删除成功'
                    });
                  }
                });

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      })));
    }
  }
};